import './application-phone-field.scss'
import 'react-phone-input-2/lib/material.css'

import { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, FormHelperText } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import ru from 'react-phone-input-2/lang/ru.json'
import { isApplicationPhoneValid } from '../reveal-contacts-form'

const ApplicationPhoneField = ({
  label,
  value,
  onChange,
  error,
  endAdornment,
}: ApplicationPhoneFieldProps) => {
  const { t, i18n } = useTranslation()
  const id = useId()
  const [ touched, setTouched ] = useState(false)
  const message = error || (touched && !isApplicationPhoneValid(value)
    ? t('errors__message__incorrectPhoneError')
    : '')

  return (
    <Box className='application-phone-field'>
      <PhoneInput
        country='ru'
        value={value}
        localization={i18n.language.startsWith('ru') ? ru : undefined}
        specialLabel={label}
        isValid={!message}
        onChange={(_, __, ___, formattedValue) => onChange(formattedValue)}
        onBlur={() => setTouched(true)}
        inputProps={{
          id,
          name: id,
          'aria-label': label,
          'aria-invalid': Boolean(message),
          'aria-describedby': message ? `${id}-error` : undefined,
          autoComplete: 'tel',
        }}
      />
      {endAdornment && (
        <Box className='application-phone-field__copy'>{endAdornment}</Box>
      )}
      {message && (
        <FormHelperText id={`${id}-error`} error className='application-phone-field__error'>
          {message}
        </FormHelperText>
      )}
    </Box>
  )
}

export default ApplicationPhoneField
